rs.module("jobs/dropinterestbatches",

    ["controls/data/grid"],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, ajaxUrl) {

            var filter = $.js(jsSelectors.filter);
            var dropPlansDropDown = filter.js(jsSelectors.dropPlansDropDown);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Hook up select event on the selectorto reload the grid data via ajax
            dropPlansDropDown.on('change', function () {

                loadingSpinner.show();

                gridModule.update(

                    ajaxUrl,
                    { selectedDropPlanKey: this.value },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);